<ion-card class="min-kartya">
  <ion-card-header>
    <ion-card-title>Minősíthetőség – mulasztás</ion-card-title>
    <ion-card-subtitle>
      20/2012. EMMI r. 51. § (7)–(8): 250 óránál több mulasztás, vagy egy tantárgyból a tanórák 30%-át
      meghaladó mulasztás esetén a tanuló nem minősíthető (osztályozó vizsga, a nevelőtestület engedélyével);
      20 óránál több igazolatlan mulasztásnál az osztályozó vizsga megtagadható, ha az iskola a szülőt az 51. § (3)
      szerint értesítette (tanköteles tanulónál az első, nem tanköteles kiskorúnál a 10. igazolatlan óránál – a rögzített
      értesítés az Igazolatlan mulasztás – értesítések kártyáról látszik). A tantárgyi arány a tanév
      elejétől máig megtartott órákhoz mér<span *ngIf="vonatkozas"> ({{ pontos(vonatkozas) }})</span>; az elmaradt
      óra, a napközi/tanulószoba és a felmentett óra nem számít, a késésből összegyűlt óra az összesbe igen.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="betolt" class="min-ures"><ion-spinner name="crescent"></ion-spinner> Számolás…</div>
    <div *ngIf="!betolt && hiba" class="min-hiba">{{ hiba }}</div>

    <ng-container *ngIf="!betolt && !hiba">
      <div class="min-eszkozok">
        <ion-checkbox labelPlacement="end" [(ngModel)]="csakKockazat">
          Csak akinél van mire figyelni ({{ kockazatosDb }} / {{ tanulok.length }})
        </ion-checkbox>
        <span class="min-jelmagyarazat">
          <span class="min-cimke min-sarga">20%</span>
          <span class="min-cimke min-narancs">25% – figyelmeztetés</span>
          <span class="min-cimke min-piros">30% fölött – nem minősíthető</span>
        </span>
        <ion-button size="small" fill="clear" (click)="betoltes()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>

      <div *ngIf="!lathatoTanulok.length" class="min-ures">
        {{ csakKockazat ? 'Egyik tanulónál sem közelít a mulasztás a határokhoz.' : 'Az osztályban nincs tanuló.' }}
      </div>

      <div class="min-tanulo" *ngFor="let t of lathatoTanulok" [class.nyitott]="nyitott === t.oktazon"
           [class.kilepett]="!!t.kilepett">
        <div class="min-fej" (click)="nyit(t)">
          <b class="min-nev">{{ t.nev }}<span class="min-halvany" *ngIf="t.kilepett"> · kilépett {{ pontos(t.kilepett) }}</span></b>

          <span class="min-cimke" [ngClass]="osszesSzint(t) ? 'min-' + osszesSzint(t) : 'min-semleges'"
                [title]="'Összes mulasztás: ' + t.osszes + ' óra (igazolt ' + t.igazolt + ', igazolatlan ' + t.igazolatlan + ', elbírálatlan ' + t.elbiralatlan + (t.keses_ora ? ', ebből késésből ' + t.keses_ora : '') + ') – a 250 órás határ: 51. § (7) a)'">
            {{ t.osszes }} óra<ng-container *ngIf="t.kockazat.osszes_nem_minositheto"> – nem minősíthető</ng-container><ng-container
              *ngIf="!t.kockazat.osszes_nem_minositheto && t.kockazat.osszes_figyel"> – közelít a 250-hez</ng-container>
          </span>

          <span class="min-cimke min-piros" *ngIf="t.kockazat.igazolatlan_megtagadhato"
                title="20 óránál több igazolatlan mulasztás: a nevelőtestület megtagadhatja az osztályozó vizsgát, ha az iskola a szülőt értesítette (51. § (8))">
            {{ t.igazolatlan }} igazolatlan – {{ t.kockazat.megtagadhato_ertesites_teljesul === false
              ? 'a megtagadáshoz hiányzik a szülő értesítése' : 'az osztályozó vizsga megtagadható' }}
          </span>
          <span class="min-cimke" *ngIf="t.kockazat.igazolatlan_megtagadhato && t.szuloi_ertesites as se"
                [ngClass]="se.kotelezo && !se.rogzitve ? 'min-narancs' : 'min-rendben'"
                [title]="se.szoveg + ' (' + se.jogalap + ')' + (se.kiado ? ' – rögzítette: ' + se.kiado : '')">
            <ion-icon [name]="se.kotelezo && !se.rogzitve ? 'alert-circle-outline' : 'checkmark-circle-outline'"></ion-icon>
            {{ ertesitesCimke(se) }}
          </span>
          <span class="min-halvany" *ngIf="!t.kockazat.igazolatlan_megtagadhato && t.igazolatlan">{{ t.igazolatlan }} igazolatlan</span>

          <span class="min-targyak">
            <span *ngFor="let x of jelzettTargyak(t)" class="min-cimke" [ngClass]="'min-' + x.szint" [title]="targyCim(x)">
              {{ x.tantargy }} {{ x.szazalek }}% ({{ x.mulasztott }}/{{ x.megtartott }})<ng-container
                *ngIf="targyCimke(t, x) as c"> – {{ c }}</ng-container>
            </span>
          </span>

          <!--  GYORSJELÖLÉS a piros okokra (a kinyitás nélkül); jelölt oknál ugyanez a gomb visszavon. -->
          <span class="min-gyors" *ngIf="t.gyors?.length" (click)="$event.stopPropagation()">
            <ion-button *ngFor="let g of t.gyors" size="small" [fill]="g.jeloles ? 'outline' : 'solid'"
                        [color]="g.jeloles ? 'medium' : 'danger'" [disabled]="mentes" (click)="gyorsJelol(t, g)"
                        [title]="g.jeloles ? 'Jelölve: ' + g.jeloles.szoveg + ' – kattintásra visszavonás'
                          : 'Osztályozó vizsgára jelölés – ' + g.nev + ', ' + idoszakNev(javasoltIdoszak) + ' értékelés'">
              <ion-icon slot="start" [name]="g.jeloles ? 'arrow-undo-outline' : 'ribbon-outline'"></ion-icon>
              <ng-container *ngIf="!g.jeloles">Osztályozó vizsgára jelölöm: {{ g.nev }}</ng-container>
              <ng-container *ngIf="g.jeloles">Jelölve ({{ g.nev }}) – visszavonás</ng-container>
            </ion-button>
          </span>

          <span class="min-ov" *ngIf="t.jelolesek.length">
            <ion-icon name="ribbon-outline"></ion-icon> osztályozó vizsga: {{ t.jelolesek.length }}
          </span>
          <ion-icon class="min-nyil" [name]="nyitott === t.oktazon ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </div>

        <div class="min-test" *ngIf="nyitott === t.oktazon">
          <table class="min-tabla" *ngIf="t.tantargyak.length">
            <thead>
              <tr><th>Tantárgy</th><th>Megtartott</th><th>Mulasztott</th><th>Igazolatlan</th><th>%</th><th>Tanév (órarend)</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let x of t.tantargyak">
                <td>{{ x.tantargy || '–' }}</td>
                <td>{{ x.megtartott }}</td>
                <td>{{ x.mulasztott }}</td>
                <td>{{ x.igazolatlan }}</td>
                <td><span class="min-cimke" [ngClass]="'min-' + x.szint" [title]="targyCim(x)">{{ x.szazalek }}%</span></td>
                <td [title]="'A tanév órarendi óráinak 30%-a: ' + harmincSzazalek(x) + ' óra'">{{ x.tervezett }}</td>
              </tr>
            </tbody>
          </table>

          <div class="min-jelolesek">
            <h4>Osztályozó vizsga</h4>
            <div *ngIf="!t.jelolesek.length" class="min-halvany">Nincs jelölés.</div>
            <div class="min-jeloles" *ngFor="let j of t.jelolesek">
              <span>{{ j.szoveg }}</span>
              <ion-button size="small" fill="clear" color="medium" [disabled]="mentes" (click)="visszavon(j)">
                <ion-icon slot="start" name="arrow-undo-outline"></ion-icon>Visszavonás
              </ion-button>
            </div>

            <div class="min-urlap">
              <ion-select label="Tantárgy" labelPlacement="stacked" interface="popover" [(ngModel)]="uj.tantargy">
                <ion-select-option value="">Minden tantárgyból (250 óra fölött)</ion-select-option>
                <ion-select-option *ngFor="let x of t.tantargyak" [value]="x.tantargy_id">
                  {{ x.tantargy }} ({{ x.szazalek }}%)
                </ion-select-option>
              </ion-select>
              <ion-select label="Értékelés" labelPlacement="stacked" interface="popover" [(ngModel)]="uj.idoszak">
                <ion-select-option value="felev">Félévi</ion-select-option>
                <ion-select-option value="ev_vege">Év végi</ion-select-option>
              </ion-select>
              <ion-input label="Megjegyzés" labelPlacement="stacked" [(ngModel)]="uj.megjegyzes" maxlength="500"
                         placeholder="pl. nevelőtestületi határozat száma"></ion-input>
              <ion-button size="small" [disabled]="mentes" (click)="jelol(t)">
                <ion-icon slot="start" name="ribbon-outline"></ion-icon>Osztályozó vizsgára jelölöm
              </ion-button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
